<template>
    <div>
        <p v-if="puestos.length === 0"><i>No hay puestos capturados</i></p>
        
        <b-card-group v-else columns>
            <b-card v-for="(element,index) in puestos" :key="index"
                    :title="element.nombre"
                    :img-src="puestoImg(index)"
                    img-fluid
                    img-alt="image"
                    style="max-width: 15rem;"
                    img-top>
                <b-badge v-if="element.visible" class="pull-right" variant="success">Visible</b-badge>
                <b-badge v-else class="pull-right" variant="danger">Oculto</b-badge>
                <p class="card-text">
                    {{element.puesto}}
                </p>
                <b-button variant="primary" size="sm" @click="verPuesto(element._id)">Detalles</b-button>
            </b-card>

        </b-card-group>

        <b-button v-if="puedeAgregarPuesto"
                variant="primary" 
                size="sm" 
                class="pull-right"
                @click="agregarPuesto()">
            Agregar puesto
        </b-button>
        
    </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

    
export default {
  name: 'ItemPuesto',
  props:["puestos"],
  components: {},
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregarPuesto(){
        if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 127) >= 0 )
            return true;
        else
            return false;
    },
  },
  watch: {
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        id: this.$route.params.id
    }
  },
  methods: {
    verPuesto(id){
        this.$router.push('puesto/'+id);
    },
    agregarPuesto(){
        this.$emit('enviandoStart');
          axios.post(this.httpURL+'/comsocial/directorio/puesto/'+this.id,
                {},
                {headers: {token:this.sessionToken}})
            .then(res => {
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.puestos.push(res.data.puesto);
                this.$emit('enviandoStop');
            })
            .catch(error => {
                this.$emit('enviandoStop');
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    puestoImg(index){
        if( !this.puestos[index].imagen.path )
            return "/img/no-user-image.png";
        else
            return this.httpURL+'/'+this.puestos[index].imagen.path;
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	
	top: 50%;
	display: block;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
